<template>
  <div>
    <swiper
      class="banner"
      ref="mySwiper"
      :options="swiperOptions"
      v-if="bannerON"
    >
      <swiper-slide v-for="(item, index) in banner" :key="'banner' + index">
        <div class="swiper-list">
          <img :src="item.pc" alt="" class="only-pc" />
          <img
            :src="item.mob"
            alt=""
            class="only-mob"
          />
        </div>
      </swiper-slide>
      <!-- 分页器 -->
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div class="news max-w flex">
      <div class="top">
        <div class="title flex">
          <div class="txt">
            <div class="up"><span>资讯</span>中心</div>
            <div class="bg">NEWS</div>
          </div>
          <router-link to="/news" class="more tra">MORE</router-link>
        </div>
        <div class="list">
          <router-link
            v-for="(item, index) in newsList"
            :key="'news' + index"
            :to="`/newsView/${item.id}`"
            @click.native="searchOpen = false"
            >{{ item.name }}</router-link
          >
        </div>
      </div>
      <div class="infobox">
        <div class="title">行业资讯<span>/Industry</span></div>
        <div class="info">
          {{
            formatHtml(industryInfo[0] ? industryInfo[0].detail : "").slice(
              0,
              115
            )
          }}
        </div>
        <router-link to="/news/industry" class="more more-white tra"
          >MORE</router-link
        >
      </div>
      <div class="infobox">
        <div class="title">培训信息<span>/train</span></div>
        <div class="info">
          {{
            formatHtml(trainInfo[0] ? trainInfo[0].detail : "").slice(0, 115)
          }}
        </div>
        <router-link to="/news/train" class="more tra">MORE</router-link>
      </div>
    </div>
    <div class="partner max-w">
      <div class="title">
        <div class="en">-cluster partner-</div>
        <div class="cn">集群伙伴</div>
      </div>
      <div class="over">
        <div class="info flex">
          <a
            v-for="(item, index) in partner"
            :key="'partant' + index"
            :href="item.link ? item.link : 'javascript:void(0);'"
            :target="item.link ? '_blank' : '_self'"
            class="box"
            ><img :src="item.img" :alt="item.title"
          /></a>
          <div
            class="box no-height"
            v-for="(i, index) in 8"
            :key="'k' + index"
          ></div>
        </div>
      </div>
    </div>
    <div class="aboutus">
      <div class="max-w">
        <div class="top flex">
          <div class="left">
            <div class="title">
              <div class="up">关于<span>我们</span></div>
              <div class="bg">ABOUT US</div>
            </div>
            <div class="txt">
              乐清电气产业创新发展服务中心(以下简称“中心”)是在由浙江省电气行业协会和浙江省低压电气技术创新联盟基础上,组建成立的新型的、非政府的、非营利性的集群发展促进机构,该机构由<span>龙头企业正泰、浙江省电气行业协会、国家低压电气质量监督检验中心</span>作为发起单位。中心重点围绕电气产业在企业培育、技术创新、网络化协作、集群健康发展等领域的重大需求,促进电力装备产业集群培育打造,为乐清市电气先进制造集群搭建产业技术创新、信息集成交流、检验检测、投融资、人才培训、宣传展示等平台。
            </div>
            <div class="img only-mob">
              <img
                src="@/assets/images/index/about.png"
                alt="产业创新发展中心"
              />
            </div>

            <router-link to="/about" class="more tra">更多</router-link>
          </div>
          <div class="right only-pc">
            <img src="@/assets/images/index/about.png" alt="产业创新发展中心" />
          </div>
        </div>
        <div class="bottom flex">
          <div class="info">
            <div class="title">常务理事</div>
            <div class="num">30<span>名</span></div>
          </div>
          <div class="symbol">=</div>
          <div class="info">
            <div class="title">龙头骨干企业</div>
            <div class="num">15<span>家</span></div>
          </div>
          <div class="symbol">+</div>
          <div class="info">
            <div class="title">行业协会</div>
            <div class="num">5<span>家</span></div>
          </div>
          <div class="symbol">+</div>
          <div class="info">
            <div class="title">其他机构</div>
            <div class="num">10<span>家</span></div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 30px"></div>
  </div>
</template>

<script>
import { getIndex } from "@/api/web";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "Index",
  components: {
    Swiper,
    SwiperSlide,
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  data() {
    return {
      banner: [],
      newsList: [],
      partner: [],
      industryInfo: [{ detail: "" }],
      trainInfo: [{ detail: "" }],
      bannerON: false,
      swiperOptions: {
        loop: true,
        autoplay: true,
        pagination: {
          // 分页
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
  created() {
    getIndex().then((res) => {
      let banner = res.data.banner;
      let pc = banner.pc.split(",");
      let mob = banner.mobile.split(",");
      for (let index = 0; index < pc.length; index++) {
        this.banner.push({ pc: pc[index], mob: mob[index] });
      }
      if (this.banner.length < 2) {
        this.swiperOptions.autoplay = false;
        this.swiperOptions.loop = false;
      }
      this.newsList = res.data.newsList;
      this.partner = res.data.partner;
      this.industryInfo = res.data.industryInfo;
      this.trainInfo = res.data.trainInfo;
      this.bannerON = true;
    });
  },
};
</script>
<style lang="scss" scoped>
.banner {
  img {
    width: 100%;
    vertical-align: bottom;
  }
  ::v-deep .swiper-pagination {
    .swiper-pagination-bullet {
      width: 60px;
      height: 6px;
      background: #ffffff;
      opacity: 0.6;
      border-radius: 8px;
      transition: width 0.5s;
      @media only screen and (max-width: 1200px) {
        width: 26px;
      }
    }
    .swiper-pagination-bullet-active {
      width: 16px;
      opacity: 1;
    }
    @media only screen and (min-width: 1200px) {
      width: auto;
      text-align: right;
      right: calc(50vw - 600px + 20px);
      left: auto;
      bottom: 60px;
    }
  }
}
.news {
  align-items: flex-start;
  & > div {
    padding: 60px 30px;
    box-sizing: border-box;
    @media only screen and (max-width: 1200px) {
      padding-top: 40px;
      padding-bottom: 30px;
    }
  }
  .more {
    color: #3d8aff;
    border: 1px solid;
    border-color: #3d8aff;
    font-size: 14px;
    border-radius: 17px;
    padding: 6px 16px;
    display: inline-block;
    &:hover {
      color: #fff;
      background: #3d8aff;
    }
  }
  .more-white {
    color: #fff;
    border-color: #fff;
    &:hover {
      color: #3d8aff;
      background: #fff;
    }
  }
  .top {
    width: 520px;
    .title {
      color: #3d8aff;
      .txt {
        width: 100%;
        position: relative;
        .up {
          font-weight: bold;
          font-size: 24px;
          position: relative;
          z-index: 10;
          color: #333333;
          span {
            color: #3d8aff;
          }
        }
        .bg {
          color: #c4c4c4;
          font-size: 40px;
          position: absolute;
          font-weight: bold;
          left: 10px;
          bottom: 5px;
          z-index: 9;
        }
      }
    }
    .list {
      a {
        display: block;
        position: relative;
        color: #666666;
        padding: 20px 0 16px 18px;
        border-bottom: 1px solid #e5e5e5;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &:first-child {
          margin-top: 10px;
        }

        &::before {
          content: "";
          width: 8px;
          height: 8px;
          border: 1px solid #c4c4c4;
          position: absolute;
          left: 0;
          border-radius: 100%;
          top: 24px;
        }
        &:hover {
          color: #3d8aff;
          &::before {
            border-color: #3d8aff;
          }
        }
        @media only screen and (max-width: 1200px) {
          white-space: normal;
          line-height: 1.5;
          width: 100%;
          &::before {
            top: 28px;
          }
        }
      }
    }
  }
  .infobox {
    width: 340px;
    background: #3d8aff;
    color: #fff;
    .title {
      font-size: 24px;
      font-weight: bold;
      span {
        font-size: 18px;
        text-transform: uppercase;
        font-weight: lighter;
        margin-left: 10px;
      }
    }
    .info {
      margin: 30px 0 55px;
      line-height: 1.5;
      height: 140px;
      overflow: hidden;
      @media only screen and (max-width: 1200px) {
        height: auto;
      }
    }
    &:last-child {
      background: #e6efff;
      color: #3d8aff;
    }
    @media only screen and (max-width: 1200px) {
      width: 100%;
    }
  }
  @media only screen and (max-width: 1200px) {
    padding: 0;
    flex-wrap: wrap;
  }
}
.partner {
  padding-top: 60px;
  padding-bottom: 60px;
  .title {
    text-align: center;
    .en {
      text-transform: uppercase;
      color: #3d8aff;
      font-weight: lighter;
      font-size: 40px;
      @media only screen and (max-width: 1200px) {
        font-size: 26px;
      }
    }
    .cn {
      font-weight: bold;
      font-size: 24px;
      color: #333333;
      margin-top: 10px;
    }
  }
  .over {
    @media only screen and (max-width: 1200px) {
      overflow-x: auto;
    }
    .info {
      flex-wrap: wrap;
      margin-top: 20px;
      .box {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20%;
        height: 146px;
        img {
          width: 146px;
        }
      }
      .no-height {
        height: 0 !important;
      }
      @media only screen and (max-width: 1200px) {
        .box {
          width: 100px;
          height: 80px;
          img {
            width: 90%;
          }
        }
      }
    }
  }
  @media only screen and (max-width: 1200px) {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
.aboutus {
  background: #eff8ff;
  padding: 110px 0;
  overflow: hidden;

  .top {
    .left {
      .title {
        color: #3d8aff;

        position: relative;
        .up {
          font-weight: bold;
          font-size: 24px;
          position: relative;
          z-index: 10;
          color: #333333;
          span {
            color: #3d8aff;
          }
        }
        .bg {
          color: #c4c4c4;
          font-size: 40px;
          position: absolute;
          font-weight: bold;
          left: 10px;
          bottom: 5px;
          z-index: 9;
        }
      }
      .txt {
        margin: 30px 0 60px;
        font-size: 18px;
        line-height: 1.8;
        color: #666666;
        span {
          color: #3d8aff;
        }
        @media only screen and (max-width: 1200px) {
          margin: 30px 0;
        }
      }
      .img {
        position: relative;
        margin-bottom: 20px;
        img {
          position: relative;
          z-index: 2;
          width: 90%;
        }
        &::after {
          content: "";
          position: absolute;
          width: 220px;
          height: 220px;
          background: #3d8aff;
          right: 0;
          bottom: -10px;
        }
      }
      .more {
        display: inline-block;
        background: #3d8aff;
        padding: 15px 60px;
        font-size: 20px;
        color: #fff;
        position: relative;
        &::after,
        &::before {
          content: "";
          width: 10px;
          height: 1px;
          background: #fff;
          top: 25px;
          position: absolute;
        }
        &::after {
          right: 30px;
        }
        &::before {
          left: 30px;
        }
        &:hover {
          background: #3068bd;
        }
        @media only screen and (max-width: 1200px) {
          margin-top: 20px;
        }
      }
    }
    .right {
      position: relative;
      margin-right: -5vw;
      margin-left: 60px;
      img {
        position: relative;
        z-index: 2;
      }
      &::after {
        content: "";
        position: absolute;
        width: 420px;
        height: 1000vh;
        background: #3d8aff;
        right: -40px;
        top: -110px;
      }
      @media only screen and (max-width: 1500px) {
        margin-right: 0;
      }
    }
  }
  .bottom {
    width: 70%;
    color: #666666;
    margin-top: 40px;
    position: relative;
    z-index: 2;
    .info {
      text-align: center;
      .title {
        font-size: 20px;
        color: #666666;
        @media only screen and (max-width: 1200px) {
          font-size: 14px;
        }
      }
      .num {
        font-size: 30px;
        color: #3d8aff;
        font-weight: bold;
        margin-top: 10px;
        @media only screen and (max-width: 1200px) {
          font-size: 20px;
        }
        span {
          font-size: 16px;
          color: #666666;
          margin-left: 6px;
          font-weight: normal;
        }
      }
    }
    .symbol {
      font-size: 30px;
      color: #3d8aff;
      font-weight: bold;
    }
    @media only screen and (max-width: 1200px) {
      width: 100%;
    }
  }
  @media only screen and (max-width: 1200px) {
    padding-top: 60px;
    padding-bottom: 40px;
  }
}
</style>
